import { render, staticRenderFns } from "./DadosPadraoPaciente.vue?vue&type=template&id=15a42968"
import script from "./DadosPadraoPaciente.vue?vue&type=script&lang=js"
export * from "./DadosPadraoPaciente.vue?vue&type=script&lang=js"
import style0 from "./DadosPadraoPaciente.vue?vue&type=style&index=0&id=15a42968&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports